import type { ConfigData } from '@/types';

export function normalizeConfigUrlForInteractivity<T extends { url?: string | null }>(
	config: T,
	interactivity: ConfigData['interactivity'],
): T {
	if (interactivity !== 'none') {
		return config;
	}

	return { ...config, url: null };
}
